<template>
    <div class="dialogTotal">
      <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled">
        <total-form :formItem="total"></total-form>
      </el-form>
    </div>
</template>

<script>
  import bus from './bus'
  import arrayData from '../assets/javascript/dataProcess'
  import totalForm from '../assets/components/form'

    export default {
        name: "dialogTotal",
      components:{
          totalForm
      },
      data() {
        return {
          disabled:true,
          totalData:{},
          total:[]
        }
      },
      methods:{
          /*数据渲染*/
          dataRender(){
            for(let i = 0;i < this.total.length;i++){
              for (let key of Object.keys(this.totalData)) {
                if(key === this.total[i].name){
                  this.total[i].value = this.totalData[key];
                }
              }
            }
          }
      },
      created(){
        this.total = arrayData.data2.total;
          /*接收数据*/
          bus.$on("total",msg=>{
            this.totalData = msg;
            this.dataRender();
          });
      }
    }
</script>

<style scoped>
  .dialogTotal{
    width: 99%;
    height: 100%;
  }
  .formMsg{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content:flex-start;
  }

</style>



// WEBPACK FOOTER //
// src/exportData/dialogTotal.vue